import React, { useState } from 'react';
import { FormattedMessage, } from '../../util/reactIntl';
import { DraftContent, IconArrowHead } from '../../components';
import { isDraftTextEmpty } from '../../util/richText';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const SectionProgram = props => {
  const { name, title, description, publicData, locale, listingTranslation } = props;
  const programDay = publicData?.programDay;
  const hasDescription = description && !isDraftTextEmpty(description);

  if (!hasDescription && !programDay) return null;

  const [showSection, setShowSection] = useState(true);
  const [activeItem, setActiveItem] = useState(0);

  const handleSetActiveItem = (index) => {
    if (activeItem !== index) {
      setActiveItem(index)
    } else {
      setActiveItem(-1)
    }
  };

  const programDayTranslated = listingTranslation?.[`programDay_locale_${locale}`];
  const programDayData = !!programDayTranslated ? JSON.parse(programDayTranslated) : programDay;

  return (
    <section className={css.section}>
      <h2 className={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        {title}
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </h2>
      {showSection && (
        <>
          {hasDescription && <DraftContent draftContent={description} />}

          {programDayData?.map((day, i) => {
            const isActive = activeItem === i;
            return (
              <div className={css.programDay}>
                <div className={css.programDayTitle} onClick={() => handleSetActiveItem(i)}>
                  {`Day ${i + 1}`}
                  <IconArrowHead direction={isActive ? "up" : "down"} />
                </div>
                <div className={classNames(css.programDayContent, isActive && css.programDayContentActive)}>
                  {day.schedules.map(schedule => {
                    return (
                      <div className={css.programDayContentItem}>
                        <div className={css.programDayContentTime}>
                          {schedule.startTime}
                          {schedule.startTime && schedule.endTime && <span>-</span>}
                          {schedule.endTime}
                        </div>
                        <div className={css.programDayContentDescription}>
                          {schedule.description}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </>
      )}
    </section>
  );
};

export default SectionProgram;
